var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-json-renderer"},[_c('pre',[_c('code',{directives:[{name:"highlightjs",rawName:"v-highlightjs",value:({ language: 'json', code: _vm.json }),expression:"{ language: 'json', code: json }"}]})])])}
var staticRenderFns = []

export { render, staticRenderFns }